import React, { useState, useEffect } from 'react';

const GyongyFogaszat = () => {
  const [activeSection, setActiveSection] = useState('home');

  // Smooth scrolling function
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  useEffect(() => {
    // Set page title and meta description
    document.title = "Gyöngy Fogászat | Fájdalommentes kezelések | Budapest 9. kerület";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Gyöngy Fogászat – prémium, fájdalommentes kezelések Budapest IX. kerületében. Esztétikai fogászat, fogpótlás, szájsebészet és gyermekfogászat modern technológiával');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Modern Sticky Header */}
      <header className="bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-full flex items-center justify-center shadow-lg">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                  Gyöngy Fogászat
                </h1>
                <p className="text-sm text-gray-500">Fájdalommentes ellátás</p>
              </div>
            </div>

            {/* Navigation */}
            <nav className="hidden md:flex items-center space-x-1">
              <button 
                onClick={() => scrollToSection('home')}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${
                  activeSection === 'home' 
                    ? 'text-blue-600 bg-blue-50 shadow-sm' 
                    : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                Főoldal
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${
                  activeSection === 'services' 
                    ? 'text-blue-600 bg-blue-50 shadow-sm' 
                    : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                Szolgáltatások
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${
                  activeSection === 'about' 
                    ? 'text-blue-600 bg-blue-50 shadow-sm' 
                    : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                Rólunk
              </button>
              <button 
                onClick={() => scrollToSection('prices')}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${
                  activeSection === 'prices' 
                    ? 'text-blue-600 bg-blue-50 shadow-sm' 
                    : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                Árak
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="px-4 py-2 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg font-medium text-sm hover:from-blue-700 hover:to-cyan-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 ml-2"
              >
                Kapcsolat
              </button>
            </nav>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button className="p-2 rounded-lg text-gray-600 hover:text-blue-600 hover:bg-gray-50">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="relative overflow-hidden bg-gradient-to-br from-blue-50 via-white to-cyan-50 py-20">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fillRule='evenodd'%3E%3Cg fill='%23E0F2FE' fillOpacity='0.3'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Text Content */}
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                15+ év tapasztalat Budapest szívében
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Ragyogó mosoly,
                <span className="block bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                  fájdalommentes
                </span>
                kezelés
              </h1>
              
              <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-2xl">
                Prémium fogászati ellátás Budapest IX. kerületében. Dr. Róka Zsuzsanna szakorvos 
                és tapasztalat csapata várja Önt modern technológiával és személyre szabott kezeléssel.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-xl font-semibold text-lg hover:from-blue-700 hover:to-cyan-600 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                  Időpont foglalás
                </button>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="px-8 py-4 bg-white text-gray-700 rounded-xl font-semibold text-lg hover:bg-gray-50 transition-all duration-200 shadow-md hover:shadow-lg border border-gray-200"
                >
                  Szolgáltatások
                </button>
              </div>
              
              {/* Quick Stats */}
              <div className="grid grid-cols-3 gap-8 mt-12 pt-8 border-t border-gray-200">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">15+</div>
                  <div className="text-sm text-gray-600">Év tapasztalat</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">100%</div>
                  <div className="text-sm text-gray-600">Fájdalommentes</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">2</div>
                  <div className="text-sm text-gray-600">Szakorvos</div>
                </div>
              </div>
              
            </div>

            {/* Hero Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500">
                <img 
                  src="https://images.unsplash.com/photo-1573294705900-9623cfc746b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxiZWF1dGlmdWwlMjBzbWlsZSUyMHdoaXRlJTIwdGVldGh8ZW58MHx8fHwxNzU2MjQxMzY4fDA&ixlib=rb-4.1.0&q=85" 
                  alt="Gyöngy Fogászat - Gyönyörű egészséges mosoly"
                  className="w-full h-96 lg:h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent"></div>
              </div>
              
              {/* Floating Card */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-4 border border-gray-100">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">Ingyenes konzultáció</div>
                    <div className="text-sm text-gray-500">Kezelési terv</div>
                  </div>
                </div>
              </div>

              {/* Floating Badge */}
              <div className="absolute -top-6 -right-6 bg-gradient-to-r from-blue-600 to-cyan-500 text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
                Prémium ellátás ✨
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Átfogó fogászati
              <span className="block bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                szolgáltatások
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Modern technológiával és szakértelemmel biztosítjuk a legmagasabb színvonalú fogászati ellátást minden korosztály számára.
            </p>
          </div>

          {/* Featured Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {/* Esztétikai Fogászat */}
            <div className="group bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-blue-100">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-xl mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Esztétikai fogászat</h3>
              <p className="text-gray-600 mb-6">
                Ragyogó, természetes mosoly esztétikus tömésekkel, kerámiahéjakkal és professzionális fogfehérítéssel.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Esztétikus tömés
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Kerámiahéj, direkt héj
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  ZOOM2 fogfehérítés
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Fogékszer felhelyezés
                </li>
              </ul>
            </div>

            {/* Fogpótlás */}
            <div className="group bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200">
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Fogpótlás</h3>
              <p className="text-gray-600 mb-6">
                Modern, esztétikus és tartós fogpótlások fémmentes technológiával a természetes mosoly visszaállításáért.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Cirkónium koronák
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Fémmentes fogpótlások
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Kivehető fogsorok
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Implantátumok
                </li>
              </ul>
            </div>

            {/* Gyermekfogászat */}
            <div className="group bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-purple-100">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1.5a2.5 2.5 0 002.5-2.5V6a2.5 2.5 0 00-2.5-2.5H9V10z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Gyermekfogászat</h3>
              <p className="text-gray-600 mb-6">
                Játékos, szeretetteljes környezetben gondoskodunk a legkisebbek fogainak egészségéről és szokásainak kialakításáról.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Barázdazárás
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Fogszabályozás
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Preventív kezelések
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Játékos környezet
                </li>
              </ul>
            </div>
          </div>

          {/* Additional Services Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors duration-200">
              <div className="w-12 h-12 bg-blue-100 rounded-lg mx-auto mb-4 flex items-center justify-center">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Gyökérkezelés</h4>
              <p className="text-sm text-gray-600">Precíz endodonciai beavatkozások</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors duration-200">
              <div className="w-12 h-12 bg-blue-100 rounded-lg mx-auto mb-4 flex items-center justify-center">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Fogkőeltávolítás</h4>
              <p className="text-sm text-gray-600">Ultrahangos tisztítás</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors duration-200">
              <div className="w-12 h-12 bg-blue-100 rounded-lg mx-auto mb-4 flex items-center justify-center">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Szájsebészet</h4>
              <p className="text-sm text-gray-600">Fájdalommentes beavatkozások</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors duration-200">
              <div className="w-12 h-12 bg-blue-100 rounded-lg mx-auto mb-4 flex items-center justify-center">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Preventív kezelés</h4>
              <p className="text-sm text-gray-600">Rendszeres ellenőrzés</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Image Side */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://images.unsplash.com/photo-1704455306251-b4634215d98f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxkZW50YWwlMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTYyNDAzOTh8MA&ixlib=rb-4.1.0&q=85" 
                  alt="Gyöngy Fogászat rendelő"
                  className="w-full h-96 lg:h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
              </div>
              
              {/* Experience Badge */}
              <div className="absolute -top-6 -right-6 bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-1">15+</div>
                  <div className="text-sm text-gray-600">Év tapasztalat</div>
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div>
              <div className="mb-8">
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                  Rólunk -
                  <span className="block bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                    Gyöngy Fogászat
                  </span>
                </h2>
                
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  A <strong>Gyöngy Fogászati rendelőt</strong> több, mint 15 éves magánpraxis tapasztalattal 
                  nyitottuk meg Budapest IX. kerületében. Igyekeztünk minden igényt kielégítő, modern, 
                  ugyanakkor barátságos fogorvosi rendelőt kialakítani.
                </p>
                
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Színvonalas, egyben nyugodt és fájdalommentes ellátás csak megfelelően kialakított 
                  háttér mellett lehetséges. A szakmai ismeretek folyamatos frissítése és fejlesztése 
                  elengedhetetlen munkánk sikeréhez.
                </p>

                <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-xl mb-8">
                  <p className="text-blue-900 font-medium italic">
                    "A Gyöngy nem csak az egyik legszebb magyar szavunk, egy drágakő, értéket képvisel. 
                    Fehér fényével az egyszerűséget, tisztaságot jelképezi, ugyanakkor fokozza viselője szépségét. 
                    Maga a harmónia."
                  </p>
                </div>

                {/* Core Values */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                  <div className="flex items-center space-x-3 p-4 bg-white rounded-xl shadow-sm">
                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                      <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                    </div>
                    <span className="font-medium text-gray-900">Fájdalommentes kezelés</span>
                  </div>
                  
                  <div className="flex items-center space-x-3 p-4 bg-white rounded-xl shadow-sm">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                      <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                    </div>
                    <span className="font-medium text-gray-900">Minőségi garancia</span>
                  </div>
                </div>
              </div>

              {/* Team Section */}
              <div className="space-y-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Szakértő csapatunk</h3>
                
                {/* Dr. Ka Zsuzsanna - módosítva fotóval */}
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-start space-x-4">
                    <div className="w-16 h-16 shrink-0 rounded-xl overflow-hidden">
                      <img 
                        src="http://gyongyfogaszat.hu/wp-content/uploads/2014/12/dr-roka-zsuzsanna.jpg" 
                        alt="Dr. Róka Zsuzsanna"
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.parentNode.innerHTML = '<div class="w-16 h-16 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-xl flex items-center justify-center"><span class="text-white font-bold text-lg">DR</span></div>';
                        }}
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-gray-900 mb-2">Dr. Róka Zsuzsanna</h4>
                      <p className="text-blue-600 font-medium mb-3">Fogszakorvos</p>
                      <p className="text-gray-600 text-sm mb-3">
                        1986 – fogorvosi diploma a Debreceni Orvostudományi Egyetem Fogorvostudományi Karán<br/>
                        1991 – szakvizsga, fog és szájbetegségek szakorvosa
                      </p>
                      <p className="text-gray-600 text-sm">
                        19 éve dolgozom vezető fogorvosként, szakterületem az esztétikai fogászat és a fogpótlástan. 
                        Magyarországon az elsők között kezdtem a fémmentes fogpótlások alkalmazását.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Muzs Judit - módosítva fotóval */}
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-start space-x-4">
                    <div className="w-16 h-16 shrink-0 rounded-xl overflow-hidden">
                      <img 
                        src="http://gyongyfogaszat.hu/wp-content/uploads/2024/02/IMG_3715_new.jpg" 
                        alt="Muzs Judit"
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.parentNode.innerHTML = '<div class="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl flex items-center justify-center"><span class="text-white font-bold text-lg">MJ</span></div>';
                        }}
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-gray-900 mb-2">Muzs Judit</h4>
                      <p className="text-green-600 font-medium mb-3">Klinikai higiénikus, fogorvosi asszisztens</p>
                      <p className="text-gray-600 text-sm">
                        20 éve dolgozom a szakmában. Számomra ez egy olyan hivatás, amit a legnagyobb 
                        szeretettel és tisztelettel végzek a kezdetek óta. Angolul és németül beszélek társalgási szinten.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Prices Section */}
      <section id="prices" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Átlátható
              <span className="block bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                árazás
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Kedvező áraink mellett ingyenes konzultációt és kezelési tervet biztosítunk minden páciensünknek.
            </p>
          </div>

          {/* Free Services Highlight */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl border border-green-200">
              <div className="w-16 h-16 bg-green-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Konzultáció</h3>
              <p className="text-2xl font-bold text-green-600 mb-2">INGYENES</p>
              <p className="text-sm text-gray-600">Kezelési terv</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl border border-green-200">
              <div className="w-16 h-16 bg-green-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v6a2 2 0 002 2h2m6-14h2a2 2 0 012 2v6a2 2 0 01-2 2h-2m-6 2h6" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Kontroll</h3>
              <p className="text-2xl font-bold text-green-600 mb-2">INGYENES</p>
              <p className="text-sm text-gray-600">Félévenkénti</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl border border-green-200">
              <div className="w-16 h-16 bg-green-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Kismama szűrés</h3>
              <p className="text-2xl font-bold text-green-600 mb-2">INGYENES</p>
              <p className="text-sm text-gray-600">Terhességi gondozás</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-200">
              <div className="w-16 h-16 bg-blue-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Góckutatás</h3>
              <p className="text-2xl font-bold text-blue-600 mb-2">3.000 Ft</p>
              <p className="text-sm text-gray-600">Alapos vizsgálat</p>
            </div>
          </div>

          {/* Price Categories */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Esztétikai fogászat */}
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 border border-blue-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-8 h-8 bg-blue-500 rounded-lg mr-3 flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                Esztétikai fogászat
              </h3>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center py-3 border-b border-blue-200">
                  <span className="text-gray-700">Esztétikus tömés (egy felszínű)</span>
                  <div className="text-right">
                    <span className="text-gray-400 line-through text-sm mr-2">29.000 Ft</span>
                    <span className="text-blue-600 font-bold">24.000 Ft</span>
                  </div>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-blue-200">
                  <span className="text-gray-700">Esztétikus tömés (több felszínű)</span>
                  <div className="text-right">
                    <span className="text-gray-400 line-through text-sm mr-2">32.000 Ft</span>
                    <span className="text-blue-600 font-bold">27.000 Ft</span>
                  </div>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-blue-200">
                  <span className="text-gray-700">Kompozit inlay</span>
                  <span className="text-blue-600 font-bold">45.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-blue-200">
                  <span className="text-gray-700">Kerámia inlay</span>
                  <span className="text-blue-600 font-bold">50.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3">
                  <span className="text-gray-700">Porcelán-héj</span>
                  <span className="text-blue-600 font-bold">80.000 Ft</span>
                </div>
              </div>
            </div>

            {/* Fogpótlások */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-8 h-8 bg-green-500 rounded-lg mr-3 flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                Fogpótlások
              </h3>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center py-3 border-b border-green-200">
                  <span className="text-gray-700">Fémvázas porcelán korona</span>
                  <div className="text-right">
                    <span className="text-gray-400 line-through text-sm mr-2">63.000 Ft</span>
                    <span className="text-green-600 font-bold">58.000 Ft</span>
                  </div>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-green-200">
                  <span className="text-gray-700">Cirkónium korona</span>
                  <div className="text-right">
                    <span className="text-gray-400 line-through text-sm mr-2">87.000 Ft</span>
                    <span className="text-green-600 font-bold">82.000 Ft</span>
                  </div>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-green-200">
                  <span className="text-gray-700">Porcelán-jacket korona</span>
                  <span className="text-green-600 font-bold">80.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-green-200">
                  <span className="text-gray-700">Gyökérkezelés</span>
                  <span className="text-green-600 font-bold">25.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3">
                  <span className="text-gray-700">Gyökértömés</span>
                  <span className="text-green-600 font-bold">25.000 Ft</span>
                </div>
              </div>
            </div>

            {/* Szájsebészet & Tisztítás */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 border border-purple-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-8 h-8 bg-purple-500 rounded-lg mr-3 flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
                  </svg>
                </div>
                Szájsebészet & Tisztítás
              </h3>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center py-3 border-b border-purple-200">
                  <span className="text-gray-700">Fogeltávolítás</span>
                  <span className="text-purple-600 font-bold">23.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-purple-200">
                  <span className="text-gray-700">Bölcsességfog eltávolítás</span>
                  <span className="text-purple-600 font-bold">28.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-purple-200">
                  <span className="text-gray-700">Ultrahangos fogkőeltávolítás</span>
                  <span className="text-purple-600 font-bold">23.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-purple-200">
                  <span className="text-gray-700">+ Air-brush sópolírozás</span>
                  <span className="text-purple-600 font-bold">27.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3">
                  <span className="text-gray-700">Tasakkezelés (fél fogív)</span>
                  <span className="text-purple-600 font-bold">20.000 Ft</span>
                </div>
              </div>
            </div>

            {/* Speciális kezelések */}
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 border border-orange-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-8 h-8 bg-orange-500 rounded-lg mr-3 flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                Speciális kezelések
              </h3>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <span className="text-gray-700">Rendelői fogfehérítés</span>
                  <div className="text-right">
                    <span className="text-gray-400 line-through text-sm mr-2">80.000 Ft</span>
                    <span className="text-orange-600 font-bold">70.000 Ft</span>
                  </div>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <span className="text-gray-700">Páros fogfehérítés</span>
                  <div className="text-right">
                    <span className="text-gray-400 line-through text-sm mr-2">120.000 Ft</span>
                    <span className="text-orange-600 font-bold">100.000 Ft</span>
                  </div>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <span className="text-gray-700">Fogékszer</span>
                  <span className="text-orange-600 font-bold">10.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3 border-b border-orange-200">
                  <span className="text-gray-700">Harapásemelő sín</span>
                  <span className="text-orange-600 font-bold">30.000 Ft</span>
                </div>
                
                <div className="flex justify-between items-center py-3">
                  <span className="text-gray-700">Ideiglenes tömés</span>
                  <span className="text-orange-600 font-bold">5.000 Ft</span>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Options */}
          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8 border border-blue-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Fizetési lehetőségek</h3>
              <p className="text-gray-600 mb-6">Rugalmas fizetési módokat biztosítunk pácienseink kényelme érdekében</p>
              <div className="flex flex-wrap justify-center gap-4">
                <span className="px-4 py-2 bg-white rounded-lg text-gray-700 font-medium shadow-sm">💳 Bankkártya</span>
                <span className="px-4 py-2 bg-white rounded-lg text-gray-700 font-medium shadow-sm">💵 Készpénz</span>
                <span className="px-4 py-2 bg-white rounded-lg text-gray-700 font-medium shadow-sm">🏦 Átutalás</span>
                <span className="px-4 py-2 bg-white rounded-lg text-gray-700 font-medium shadow-sm">📋 Részletfizetés</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gradient-to-br from-blue-600 to-cyan-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Vegye fel velünk
              <span className="block">a kapcsolatot</span>
            </h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Időpontfoglalás és részletes tájékoztatás telefonon vagy személyesen rendelőnkben
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div className="space-y-8">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
                <h3 className="text-2xl font-bold text-white mb-6">Elérhetőségek</h3>
                
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-white mb-1">Cím</h4>
                      <p className="text-blue-100">1094 Budapest, Páva utca 8.</p>
                      <p className="text-blue-100 text-sm">IX. kerület, irodaház földszint</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-white mb-1">Telefon</h4>
                      <p className="text-blue-100 text-xl font-bold">06 20 474 3694</p>
                      <p className="text-blue-100 text-sm">Időpontfoglalás és információ</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-white mb-1">Nyitvatartás</h4>
                      <div className="text-blue-100 space-y-1">
                        <p>Hétfő: 8:00 - 19:00</p>
                        <p>Kedd: 8:00 - 19:00</p>
                        <p>Szerda: 8:00 - 19:00</p>
                        <p>Csütörtök - Péntek: Zárva</p>
                        <p>Hétvégén: Zárva</p>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v6a2 2 0 002 2h2m6-14h2a2 2 0 012 2v6a2 2 0 01-2 2h-2m-6 2h6" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-white mb-1">Sürgősségi esetek</h4>
                      <p className="text-blue-100">Sürgősségi esetekben is hívható</p>
                      <p className="text-blue-100 text-sm">24/7 elérhetőség</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Google Map */}
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
                <h3 className="text-2xl font-bold text-white mb-4">Megközelítés</h3>
                <div className="rounded-xl overflow-hidden h-64 mb-4">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2695.832623441334!2d19.069111976593803!3d47.48096117917491!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741dcf8d9fc069d%3A0x75c03060ff0e0766!2sGy%C3%B6ngy%20Fog%C3%A1szat%20-%209.%20ker%C3%BClet%20fog%C3%A1szat%2C%20Budapest%20fogorvos%2C%20f%C3%A1jdalommentes%2C%20olcs%C3%B3%20fog%C3%A1szat!5e0!3m2!1sen!2sus!4v1735242700000!5m2!1sen!2sus"
                    width="100%"
                    height="256"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full h-full"
                  ></iframe>
                </div>
                <div className="space-y-2 text-blue-100 text-sm">
                  <p className="flex items-center">
                    <span className="text-lg mr-2">🚇</span>
                    Metro: Kálvin tér (M3, M4) - 5 perc gyalog
                  </p>
                  <p className="flex items-center">
                    <span className="text-lg mr-2">🚌</span>
                    Autóbusz: 15, 115 - Páva utca megálló
                  </p>
                  <p className="flex items-center">
                    <span className="text-lg mr-2">🚗</span>
                    Parkolás: Utcai fizetős parkolás
                  </p>
                  <p className="flex items-center">
                    <span className="text-lg mr-2">🚶</span>
                    Akadálymentes megközelítés: Földszinti rendelő
                  </p>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="space-y-8">
              <div className="bg-white rounded-2xl p-8 shadow-2xl">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Időpontfoglalás</h3>
                
                <div className="space-y-6">
                  <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border border-green-200">
                    <div className="w-16 h-16 bg-green-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">Hívjon minket!</h4>
                    <p className="text-3xl font-bold text-green-600 mb-3">06 20 474 3694</p>
                    <p className="text-gray-600">A leggyorsabb módja az időpontfoglalásnak</p>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="text-center p-4 bg-blue-50 rounded-xl">
                      <div className="w-12 h-12 bg-blue-500 rounded-full mx-auto mb-3 flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <h5 className="font-semibold text-gray-900 mb-1">Ingyenes konzultáció</h5>
                      <p className="text-sm text-gray-600">Kezelési terv</p>
                    </div>

                    <div className="text-center p-4 bg-purple-50 rounded-xl">
                      <div className="w-12 h-12 bg-purple-500 rounded-full mx-auto mb-3 flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <h5 className="font-semibold text-gray-900 mb-1">Rugalmas időpontok</h5>
                      <p className="text-sm text-gray-600">Este és hétvégén is</p>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6">
                    <h4 className="font-bold text-gray-900 mb-3">Miért válassza a Gyöngy Fogászatot?</h4>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li className="flex items-center">
                        <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        15+ év szakmai tapasztalat
                      </li>
                      <li className="flex items-center">
                        <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        100% fájdalommentes kezelés
                      </li>
                      <li className="flex items-center">
                        <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        Modern technológia és eszközök
                      </li>
                      <li className="flex items-center">
                        <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        Személyre szabott kezelés
                      </li>
                      <li className="flex items-center">
                        <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        Kedvező árak, átlátható díjszabás
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Logo and Description */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold">Gyöngy Fogászat</h3>
              </div>
              <p className="text-gray-400 mb-4 max-w-md">
                Prémium fogászati ellátás Budapest IX. kerületében. Dr. Róka Zsuzsanna szakorvos 
                és tapasztalat csapata 15+ év tapasztalattal várja Önt.
              </p>
              <div className="flex space-x-4">
                <a href="tel:0620474369" className="text-gray-400 hover:text-white transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                </a>
                <a href="mailto:info@gyongyfogaszat.hu" className="text-gray-400 hover:text-white transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Szolgáltatások</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#services" className="hover:text-white transition-colors">Esztétikai fogászat</a></li>
                <li><a href="#services" className="hover:text-white transition-colors">Fogpótlás</a></li>
                <li><a href="#services" className="hover:text-white transition-colors">Gyermekfogászat</a></li>
                <li><a href="#services" className="hover:text-white transition-colors">Fogfehérítés</a></li>
                <li><a href="#services" className="hover:text-white transition-colors">Implantátum</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Kapcsolat</h4>
              <div className="space-y-2 text-gray-400">
                <p>📍 1094 Budapest, Páva utca 8.</p>
                <p>📞 06 20 474 3694</p>
                <p>🕒 H-K-Sz: 8:00-19:00</p>
                <p>✉️ info@gyongyfogaszat.hu</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Gyöngy Fogászat. Minden jog fenntartva. | 
              <span className="text-blue-400"> Powered by FogPortál.hu</span>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GyongyFogaszat;